export default "__VITE_ASSET__DCiXOwwA__"